
import { io } from 'socket.io-client';
import { SERVER_URL } from '../../../databucket';

// Handle reverse-proxy paths (e.g. "https://api.example.com/prod" → path "/prod/socket.io/")
const url = new URL(SERVER_URL);
const pathPrefix = url.pathname.replace(/\/+$/, ""); // "/prod", "/dev", or ""
const socketPath = pathPrefix ? `${pathPrefix}/socket.io/` : "/socket.io/";

const socket = io(url.origin, {
  path: socketPath,
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 10,
});

// Debug logging
socket.on("connect", () => console.log("[Socket] Connected:", socket.id, "path:", socketPath));
socket.on("disconnect", (reason) => console.log("[Socket] Disconnected:", reason));
socket.on("connect_error", (err) => console.log("[Socket] Connection error:", err.message));

export default socket;
